import { useFormContext } from 'react-hook-form';
import { FormField, FormItem, FormLabel, FormControl, FormMessage } from '@repo/ui';
import { Input } from '@repo/ui';
import { HTMLInputTypeAttribute } from 'react';
import { ReactElement } from 'react';

interface Props {
    className?: string;
    value?: number;
    name: string;
    label?: string;
    placeholder?: string;
    type?: HTMLInputTypeAttribute;
    disabled?: boolean;
    icon?: ReactElement; // Optional icon prop
    iconPosition?: 'left' | 'right'; // Optional prop to control icon position
}

export default function TextInputForm({
    className,
    value,
    name,
    label,
    placeholder,
    type,
    disabled = false,
    icon,
    iconPosition = 'right', // Default to left if not specified
}: Props) {
    const { control } = useFormContext();

    // Prevent scroll-induced value changes for number inputs
    const handleWheel = (e: React.WheelEvent<HTMLInputElement>) => {
        if (type === 'number') {
            e.currentTarget.blur();
        }
    };

    return (
        <FormField
            control={control}
            name={name}
            render={({ field }) => (
                <FormItem className={className}>
                    {label && (
                        <FormLabel className="text-primery-blue-900 text-nowrap font-medium md:text-[18px] text-[16px] leading-[33.73px] tracking-normal text-start">
                            {label}
                        </FormLabel>
                    )}
                    <FormControl>
                        <div className="relative">
                            {icon && (
                                <div
                                    className={`absolute inset-y-0 ${iconPosition === 'left' ? 'left-3' : 'right-3'
                                        } flex items-center pointer-events-none`}
                                >
                                    {icon}
                                </div>
                            )}
                            <Input
                                {...field}
                                type={type}
                                className={`placeholder:text-white-blue-600 ${icon ? (iconPosition === 'left' ? 'pl-10' : 'pr-10') : ''
                                    }`}
                                placeholder={placeholder}
                                onWheel={handleWheel}
                                disabled={disabled}
                            />
                        </div>
                    </FormControl>
                    <FormMessage />
                </FormItem>
            )}
        />
    );
}